const IMAGE_LOAD_TIMEOUT_MS = 5000

export const canLoadImage = (src: string): Promise<boolean> =>
	new Promise<boolean>((resolve) => {
		const image = new Image()
		const timeout = setTimeout(() => resolve(false), IMAGE_LOAD_TIMEOUT_MS)
		image.onload = () => {
			clearTimeout(timeout)
			resolve(true)
		}
		image.onerror = () => {
			clearTimeout(timeout)
			resolve(false)
		}
		image.src = src
	})
